<template>
  <div class="modalQrCode card">
    <div style="border-radius:10px;padding:10px;" class="card">
      <img
        @click="closeModalQrCode()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <p :style="window.width < 380 ? 'font-size:18px' : 'font-size:36px;'">
        <img
          style="vertical-align:middle;width:36px"
          src="@/assets/img/public_logo.png"
        />
        Eventify
      </p>
      <hr />
      <h2
        :style="
          window.width < 380
            ? 'font-size:18px;font-weight:bold'
            : 'font-size:24px;font-weight:bold'
        "
      >
        {{ $t("evenement.label_code_participant") }} :
        {{ modalQrCode.codeParticipant }}
      </h2>
      <qriously :value="modalQrCode.urlQrCode" :size="qrcodeWidth" />
      <br />
      <a
        style="font-size:12px"
        target="_blank"
        :href="modalQrCode.urlQrCode"
        >{{ modalQrCode.urlQrCode }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalQrCode",
  props: ["modalQrCode"],
  data() {
    return {
      window: {
        width: 0
      },
      modalWidth: 0,
      qrcodeWidth: 0
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    closeModalQrCode() {
      this.$store.commit("MODAL_QRCODE", {
        urlQrCode: "",
        activeModalQrCode: false,
        codeParticipant: ""
      });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (window.innerWidth > 500) {
        this.modalWidth = window.innerWidth - window.innerWidth / 2;
        this.qrcodeWidth = this.modalWidth / 2;
      } else {
        this.modalWidth = window.innerWidth;
        this.qrcodeWidth = this.modalWidth - 130;
      }
    }
  }
};
</script>
<style scoped>
.modalQrCode {
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/ModalQrCode.vue